<!-- Widget.vue -->

<template>
    <div class="su-cerceve su-h500 widget">
      <div class="widget-header">
        <h3 class="rowtitle">{{ title }}</h3>
        <span class="rowdesc">{{ desc }}</span>
      </div>
      <div class="widget-content">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        required: false
      },
      desc: {
        type: String,
        required: false
      }
    }
  };
  </script>
  

  